var map = {
	"./labmem_text_sharebtn_en.png": "94a7",
	"./labmem_text_sharebtn_jp.png": "5c50",
	"./labmem_text_sharebtn_kr.png": "ab02",
	"./labmem_text_sharebtn_sc.png": "15b2",
	"./labmem_text_sharebtn_tc.png": "9397"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6791";